export default __webpack_public_path__ + "27cc311.png";